import httpClient from "Api/httpClient";

const END_POINT = "/fe_invoice_payments";

const getFeInvoicePayments = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getFeInvoicePayment = (payment_id) => {
    if (!payment_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + payment_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printFeInvoicePayment = (payment_id) => {
    if (!payment_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?payment_id=" + payment_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createFeInvoicePayments = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateFeInvoicePayments = (payload, payment_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + payment_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteFeInvoicePayments = (payment_id) => {
    const DELETE_END_POINT = END_POINT + "/" + payment_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getFeInvoicePayments, getFeInvoicePayment, printFeInvoicePayment, createFeInvoicePayments, updateFeInvoicePayments, deleteFeInvoicePayments };
